import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=f7afa880&scoped=true&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7afa880",
  null
  
)

export default component.exports